import * as React from "react";
const SvgController20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        fill: "black",
        viewBox: "0 0 18 18"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M18 18V0H0v18h18ZM2 2h14v14H2V2Zm11 4a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm-1-3a3 3 0 1 1-2.83 4H4V5h5.17A3.001 3.001 0 0 1 12 3Zm-5 9a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm1.83-1A3.001 3.001 0 0 0 3 12a3 3 0 0 0 5.83 1H14v-2H8.83Z",
      clipRule: "evenodd"
    })
  );
export default SvgController20Px;
